import { PropsWithChildren, useEffect } from 'react';

import { useStarmanIconsState } from './_states/starman-icons';
import { getStarmanIcons } from './_states/starman-icons/get-starman-icons.util';

export function Layout({ children }: PropsWithChildren) {
  const starmanIcons = useStarmanIconsState((s) => s.starmanIcons);
  const setStarmanIcons = useStarmanIconsState((s) => s.setStarmanIcons);
  useEffect(() => {
    if (starmanIcons.length <= 0) {
      const icons = getStarmanIcons();
      setStarmanIcons(icons);
    }
  }, [setStarmanIcons, starmanIcons.length]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
